const COHORTS = [
  {
    level: "Foundation Level",
    size: "Max 6 Students",
    sizeBadge: false,
    title: "Novice & Junior",
    description: "Rules mastery, spatial board perception, basic combinations, and eliminating blunders.",
    metaLeft: "Age: 5+ & Adults",
    metaRight: "2 Sessions / Week",
    featured: false,
    testId: "cohort-foundation-card",
  },
  {
    level: "Tactical Core",
    size: "Max 5 Students",
    sizeBadge: true,
    title: "Club Intermediate",
    description: "Positional sacrifices, prophylaxis, structured opening repertoires, and rook endgames.",
    metaLeft: "Assessment Req.",
    metaRight: "3 Sessions / Week",
    featured: true,
    testId: "cohort-tactical-card",
  },
  {
    level: "Championship Track",
    size: "Max 4 / 1-on-1",
    sizeBadge: false,
    title: "Tournament Squad",
    description: "FIDE rating hunt, personalized engine analysis, opponent prep, and mental toughness.",
    metaLeft: "State / District Prep",
    metaRight: "Intensive + Weekend",
    featured: false,
    testId: "cohort-championship-card",
  },
];

export const Cohorts = () => {
  return (
    <section id="batches" className="py-20 border-b border-stone-300 bg-[#faf9f5]" data-testid="cohorts-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12">
          <div>
            <div className="font-mono text-xs uppercase tracking-widest text-emerald-800 mb-2">Chapter 02</div>
            <h2 className="font-display text-3xl uppercase tracking-tight text-emerald-950">Cohort Architecture</h2>
          </div>
          <p className="text-sm text-stone-600 max-w-md mt-4 md:mt-0">
            Structured progression ladders. Students graduate between cohorts based on tactical benchmarks.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {COHORTS.map((cohort) => (
            <div
              key={cohort.level}
              data-testid={cohort.testId}
              className={`bg-white p-6 rounded-lg flex flex-col justify-between ${
                cohort.featured ? "border-2 border-emerald-950 shadow-md" : "border border-stone-300 shadow-sm"
              }`}
            >
              <div>
                <div className="flex justify-between items-baseline mb-4">
                  <span className={`font-mono text-xs font-bold uppercase ${cohort.featured ? "text-emerald-950" : "text-emerald-800"}`}>
                    {cohort.level}
                  </span>
                  {cohort.sizeBadge ? (
                    <span className="text-xs font-mono bg-emerald-100 text-emerald-900 px-2 py-0.5 rounded">{cohort.size}</span>
                  ) : (
                    <span className="text-xs font-mono text-stone-500">{cohort.size}</span>
                  )}
                </div>
                <h3 className="font-display text-2xl uppercase tracking-tight text-stone-900 mb-2">{cohort.title}</h3>
                <p className="text-sm text-stone-600 leading-relaxed">{cohort.description}</p>
              </div>
              <div className="mt-8 pt-4 border-t border-stone-200 flex justify-between text-xs font-mono text-stone-500">
                <span>{cohort.metaLeft}</span>
                <span>{cohort.metaRight}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
